import cx from 'classnames';
import PropTypes from 'prop-types';

// Inline, form-level status banner (API errors, success notices) shown above a
// form. Wraps the shared `.alert` styles (styles/alert.scss) so every form
// surfaces server messages the same way. Renders nothing without a message.
function FormAlert({ message, variant = 'danger', className }) {
  if (!message) return null;

  return (
    <div className={cx('alert', `alert-${variant}`, className)} role="alert">
      {message}
    </div>
  );
}

FormAlert.propTypes = {
  message: PropTypes.string,
  variant: PropTypes.oneOf(['danger', 'success', 'info']),
  className: PropTypes.string,
};

export default FormAlert;
